import DualButtonCTA, { ButtonVariant } from "components/ui/DualButtonCTA";
export type FeaturedReviewProps = {
  quote?: string;
  client?: string;
  location?: string;
  bgColor?: string;
  textColor?: string;
  button1?: ButtonProps;
  button2?: ButtonProps;
};

interface ButtonProps {
  buttonText: string;
  buttonUrl: string;
  buttonVariant: ButtonVariant;
}
const FeaturedReview: React.FC<FeaturedReviewProps> = ({
  quote,
  client,
  textColor = "#fff",
  location,
  button1,
  button2,
  bgColor = "#F5F1E4"
}) => {
  return (
    <section id="featured-review-108">
      <div className="lg mx-auto mb-16 w-full  max-w-[1700px] lg:mb-0 lg:w-[90%] lg:px-8">
        <div className="relative">
          <div
            className="rounded-xl"
            style={{
              backgroundColor: bgColor
            }}
          >
            <div className="mx-auto mb-4 px-2 py-16 text-center lg:max-w-3xl ">
              <div className="">
                <div className="relative">
                  <blockquote className="">
                    <p
                      className="mb-4 text-center text-md  [text-wrap:balance] lg:text-[24px] lg:leading-[36px]"
                      style={{ color: textColor }}
                    >
                      {quote}
                    </p>
                  </blockquote>
                  <div className="pb-2">
                    <div className="flex items-center justify-center text-center">
                      <h3 className=" inline-block pb-4 text-center text-md " style={{ color: textColor }}>
                        {client} <span className="">{location}</span>
                      </h3>
                    </div>
                  </div>
                </div>
                {(button1 || button2) && <DualButtonCTA button1={button1} button2={button2} isLeftAligned={false} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedReview;
